import { CreateAccountPayload } from "../../types/rest";

export async function createNewAccount(details: CreateAccountPayload) {
  return await fetch("/v1/accounts", {
    method: "POST",
    body: JSON.stringify(details),
  });
}
